import Vue from "vue";
import Vuex from "vuex";
import * as survey from "@/store/modules/survey.js";

Vue.use(Vuex);
const LOCAL_STORAGE_USER = "user"; // user date
import {
  hasUserSurvey,
  hasUserResult,
  hasUserProfil,
  isSu,
} from "../services/dbService";

export default new Vuex.Store({
  state: {
    user: {
      loggedIn: false,
      uid: null,
      data: null,
      hasSurvey: false,
      hasResult: false,
      hasProfil: false,
      homePage: "Dashboard",
      is_su: false,
      is_su_admin: false,
    },
  },
  modules: {
    survey,
  },
  getters: {
    user(state) {
      return state.user;
    },
  },
  mutations: {
    SET_LOGGED_IN(state, value) {
      if (state.user == undefined) state.user = {};
      state.user.loggedIn = value !== null;

      if (value !== null) {
        state.user.uid = value.uid;
        /*hasUserSurvey(state.user).then((result) => {
          state.user.hasSurvey = result;
          localStorage.setItem(LOCAL_STORAGE_USER, JSON.stringify(state.user));
        });
        hasUserResult(state.user).then((result) => {
          state.user.hasResult = result;
          localStorage.setItem(LOCAL_STORAGE_USER, JSON.stringify(state.user));
        });*/
        hasUserSurvey(state.user).then((result) => {
          state.user.hasSurvey = result;
          localStorage.setItem(LOCAL_STORAGE_USER, JSON.stringify(state.user));
        });
        hasUserResult(state.user).then((result) => {
          state.user.hasResult = result;
          localStorage.setItem(LOCAL_STORAGE_USER, JSON.stringify(state.user));
        });
        hasUserProfil(state.user).then((result) => {
          state.user.hasProfil = result.hasProfil;
          state.user.position = result.position;
          state.user.nameSurname = result.nameSurname;

          localStorage.setItem(LOCAL_STORAGE_USER, JSON.stringify(state.user));
        });

        isSu(state.user).then((result) => {
          state.user.is_su = result.is_su;
          state.user.is_su_admin = result.is_su_admin;

          localStorage.setItem(LOCAL_STORAGE_USER, JSON.stringify(state.user));
        });

        localStorage.setItem(LOCAL_STORAGE_USER, JSON.stringify(state.user));
      }
    },
    SET_USER(state, data) {
      if (state.user != undefined) {
        state.user.data = data;
        localStorage.setItem(LOCAL_STORAGE_USER, JSON.stringify(state.user));
      }
    },
    UPDATE_USER_DASHBOARD(state, result) {
      state.user.hasSurvey = result.hasSurvey;
      state.user.hasResult = result.hasResult;
      state.user.hasProfil = result.hasProfil;
      state.user.position = result.position;
      state.user.nameSurname = result.nameSurname;

      localStorage.setItem(LOCAL_STORAGE_USER, JSON.stringify(state.user));
    },
    SET_IS_SU(state, data) {
      state.user.is_su = data.is_su;
      state.user.is_su_admin = data.is_su_admin;
      localStorage.setItem(LOCAL_STORAGE_USER, JSON.stringify(state.user));
    },

    DISCONNECT(state) {
      state.user = { loggedIn: false, is_su: false, is_su_admin: false };
      localStorage.setItem(LOCAL_STORAGE_USER, null);
    },
  },

  actions: {
    fetchUser({ commit }, user) {
      commit("SET_LOGGED_IN", user);

      if (user) {
        commit("SET_USER", {
          displayName: user.displayName,
          email: user.email,
        });
      } else {
        commit("SET_USER", null);
      }
    },
    async updateUserDashboard({ commit, state }) {
      var hasSurvey = await hasUserSurvey(state.user);
      var hasResult = await hasUserResult(state.user);
      var dataProfil = await hasUserProfil(state.user);
      return commit("UPDATE_USER_DASHBOARD", {
        hasSurvey: hasSurvey,
        hasResult: hasResult,
        hasProfil: dataProfil.hasProfil,
        position: dataProfil.position,
        nameSurname: dataProfil.nameSurname,
      });
    },
    updateIsSu({ commit }, data) {
      commit("SET_IS_SU", data);
    },

    disconnect({ commit }, data) {
      commit("DISCONNECT", data);
    },
  },
});
